import { Solution } from '../../types';
import { leadTimeDaysExtractor } from '../leadTimeDaysExtractor';

export function extractLeadTimeDays({ solution }: { solution: Solution }): number {
    return leadTimeDaysExtractor(solution.availability);
}
